document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".features-swiper").forEach(function (sliderEl) {
    new MinimogLibs.Swiper(sliderEl, {
      loop: true,
      speed: 600,
      spaceBetween: 30,
      slidesPerView: 1,

      pagination: {
        el: sliderEl.querySelector(".features-pagination"),
        clickable: true,
        type: "bullets",
      },
      navigation: {
      nextEl: sliderEl.querySelector(".features-button-next"),
      prevEl: sliderEl.querySelector(".features-button-prev"),
      },

      breakpoints: {
        768: {
          slidesPerView: 2,
        },
      },

      observer: true,
      observeParents: true,

      on: {
        slideChange: function () {
          if (this.pagination) {
            this.pagination.render();
            this.pagination.update();
          }
        },
      },
    });
  });

  document.querySelectorAll(".images-swiper").forEach(function (sliderEl) {
    new MinimogLibs.Swiper(sliderEl, {
      loop: true,
      speed: 600,
      loopedSlides: 4,
      loopAdditionalSlides: 16,
      spaceBetween: 30,
      slidesPerView: 1,

      navigation: {
        nextEl: sliderEl.querySelector(".swiper-button-next"),
        prevEl: sliderEl.querySelector(".swiper-button-prev"),
      },

      pagination: {
        el: sliderEl.querySelector(".features-pagination"),
        clickable: true,
        type: "bullets",
      },

      breakpoints: {
        768: {
          slidesPerView: 2,
        },
      },

      on: {
        slideChange: function () {
          if (this.pagination && this.pagination.bullets) {
            this.pagination.bullets.forEach((bullet, index) => {
              bullet.classList.toggle(
                "swiper-pagination-bullet-active",
                index === this.realIndex
              );
            });
          }
        },
      },
    });
  });


  const tabs = document.querySelectorAll(".tab-titles .tab");
  const tab_contents = document.querySelectorAll(".tab-content-wrapper");

  tabs.forEach((tab, index) => {
    tab.addEventListener("click", function () {
      tabs.forEach(t => t.classList.remove("tab-active"));
      tab_contents.forEach(c => c.classList.remove("active"));

      tab.classList.add("tab-active");
      tab_contents[index].classList.add("active");
    });
  });
});
